export default __webpack_public_path__ + "static/media/MERCEDES.3f58dc97.png";